import { watchFetchPublishedSummary } from './fetch'

export const publishedSummarySagas = [watchFetchPublishedSummary]
